import { useSelector } from "react-redux";
import { IntSelectModel } from "services/api/cplapi/CPLAPI";
import { useThunkDispatch } from "setup/redux/thunkDispatch";
import { ActivityIndicator } from "cpl-react-common/components/ActivityIndicators/ActivityIndicator";
import { SearchSelectbox } from "cpl-react-common/components/Inputs/SearchSelectbox";
import {
  getMeetingTypeSelectModels,
  selectMeetingTypeSelectModels,
  selectLastUpdateTime,
  selectLoading,
} from "./components/MeetingTypeSelectSlice";

type MeetingTypeSelectProps = {
  "data-test-id"?: string;
  handleChange: (selection: IntSelectModel) => void;
  defaultSelectedValue?: number;
  disabled?: boolean;
  enableReinitialise?: boolean;
};

const EXPIRY_PERIOD_MS = 1000 * 60 * 60; // 1 hour

const MeetingTypeSelect: React.FC<MeetingTypeSelectProps> = ({
  "data-test-id": testId,
  handleChange,
  defaultSelectedValue,
  disabled,
  enableReinitialise,
}: MeetingTypeSelectProps) => {
  const loading = useSelector(selectLoading);
  const meetingTypeSelectModels = useSelector(selectMeetingTypeSelectModels);
  const lastUpdateTime = useSelector(selectLastUpdateTime);
  const thunkDispatch = useThunkDispatch();

  const updateSelectModels = () => {
    thunkDispatch(getMeetingTypeSelectModels());
  };

  const defaultSelected = meetingTypeSelectModels.find((x) => x.value === defaultSelectedValue);

  return (
    <ActivityIndicator isBusy={loading}>
      <SearchSelectbox
        data-test-id={testId}
        handleChange={(selection) => {
          handleChange(new IntSelectModel({ value: +selection.value, label: selection.label }));
        }}
        selectOptions={meetingTypeSelectModels.map((x) => ({
          value: x.value ?? "",
          label: x.label ?? "",
        }))}
        cachingOptions={{
          lastUpdateTime,
          expiryPeriodMs: EXPIRY_PERIOD_MS,
          updateData: updateSelectModels,
          shouldUpdateOnLoad: meetingTypeSelectModels.length === 0,
        }}
        defaultSelected={
          defaultSelected !== undefined
            ? { value: defaultSelected.value ?? "", label: defaultSelected.label ?? "" }
            : undefined
        }
        disabled={disabled}
        enableReinitialise={enableReinitialise}
      />
    </ActivityIndicator>
  );
};

export default MeetingTypeSelect;
